import { useWindowSize } from 'Common/hooks/useWindowSize.hook'
import { Page } from 'Common/Page/Page'
import { max } from 'lodash'
import { Box } from '@mui/material'
import { PageHeader } from 'Common/Supplyvue-ui'
import { useInventorySummary } from 'Features/Projects/Scenarios/Inventory/Inventory.data'
import { useParams } from 'react-router-dom'
import { InventorySummaryTable } from 'Features/Projects/Scenarios/Inventory/Inventory.Summary.table'
import { Loader } from 'Common/Loader/Loader'
import { ErrorDisplay } from 'Common/Error/Error'

export const InventoryView = () => {
  const { view_width } = useWindowSize()

  const { projectId, scenarioId } = useParams<{
    projectId: string
    scenarioId: string
  }>() as { projectId: string; scenarioId: string }

  const { data, isLoading, isError, isRefetching, refetch } =
    useInventorySummary({
      projectId,
      scenarioId,
    })

  return (
    <Page>
      <Box
        sx={{
          display: 'flex',
          flex: 1,
          flexDirection: 'column',
          justifyContent: 'flex-start',
          maxWidth: view_width,
        }}
      >
        <PageHeader title="Inventory Summary" />
        {isLoading && <Loader />}
        {isError && <ErrorDisplay />}
        {data && (
          <InventorySummaryTable
            data={data}
            isRefetching={isRefetching}
            handleRefetch={() => {
              refetch()
            }}
          />
        )}
      </Box>
    </Page>
  )
}
